import React from 'react';
import classNames from 'classnames';

import Data from 'data';
import Select, { underlinerFunc } from 'ui/select';

const renderOption = ({id, name}, search) => <span><span className={`lap-class-icon lap-class-${id}`}/>{search ? underlinerFunc(name, search) : name}</span>;

export default function ClassSelect({ className, value, onChange, ...props }) {
  const getOptions = React.useCallback(() => {
    const options = {};
    for (const id of Object.values(Data.classMap)) {
      const info = Data.playerClasses[id];
      if (!Data.strings[info.name]) continue;
      if (info.parent) {
        options[info.parent] = (options[info.parent] || {title: '', options: []});
        options[info.parent].options.push({id, name: Data.strings[info.name]});
      } else {
        options[id] = (options[id] || {title: '', options: []});
        options[id].title = Data.strings[info.name];
      }
    }
    return Object.values(options);
  }, []);
  const onSelect = React.useCallback(opt => onChange(opt?.id), [onChange]);
  return (
    <Select options={getOptions}
            value={value && {id: value, name: Data.strings[Data.playerClasses[value]?.name]}}
            onChange={onSelect}
            searchLimit={10}
            searchMiddle
            className={classNames("lap-ClassSelect", className)}
            renderOption={renderOption}
            renderValue={renderOption}
            {...props}/>
  );
}
